<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
      <div class="row">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("first_name") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.first_name"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("surename") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.surename"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("email") }}
            </label>
            <app-input
              id="email"
              type="email"
              :required="true"
              v-model="inputs.email"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("position") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.position"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("phone") }}
            </label>
            <app-input
              id="phone"
              type="tel-input"
              :required="true"
              :placeholder="$t('type_contact_number')"
              v-model="inputs.phone"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("mobile") }}
            </label>
            <app-input
              id="mobile"
              type="tel-input"
              :required="true"
              :placeholder="$t('type_contact_number')"
              v-model="inputs.mobile"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("role") }}
            </label>
            <app-input
              id="roles"
              type="search-select"
              :list="roleLists"
              list-value-field="name"
              :isAnimatedDropdown="true"
              v-model="inputs.role"
              :required="true"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("primary_contact") }}
            </label>
            <app-input
              id="roles"
              type="select"
              :list="statusLists"
              v-model="inputs.primary_contact"
              :required="true"
            />
          </div>
        </div>      
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost} from "../../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    companyId: Number,
  },
  data() {
    return {
      addurl:actions.COMPANY_CONTACT_STORE,
      preloader: false,
      roleLists: [],
      inputs: {
        primary_contact: 'no',
        company_id: this.companyId,
      },
      phone: "",
      statusLists: [
        { id: "no", value: "No" },
        { id: "yes", value: "Yes" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.COMPANY_CONTACT_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getRoles() {
      this.preloader = this.hasData ? true : false;

      this.axiosGet(actions.ROLES)
        .then((response) => {
          this.roleLists = response.data.data;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.preloader = false;
        });
    },
  },

  mounted() {
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getRoles();
  },
};
</script>
